<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <!-- Page Header -->
        <v-row align="center" justify="center" class="mt-n4">
          <v-col cols="12" md="auto">
            <div class="d-flex align-center justify-center">
              <v-avatar color="primary" size="52" class="mr-3 elevation-2">
                <v-icon color="white" size="28">mdi-account-cash</v-icon>
              </v-avatar>
              <div>
                <div class="text-h5 font-weight-bold grey--text text--darken-2">Facturación de prestaciones</div>
                <div class="text-caption grey--text">Grupos de liquidación pendientes por contabilizar</div>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Filters -->
        <v-row justify="center">
          <v-col cols="12">
            <search-header-po @dataFilters="changeBusiness($event)" />
          </v-col>
        </v-row>

        <v-card class="rounded-lg mt-2">
          <v-row v-if="loading" justify="center">
            <v-col cols="12" md="10">
              <v-skeleton-loader type="table"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-data-table v-else :headers="headers" :items="filteredGroups" :items-per-page="20"
            class="elevation-0" dense :search="search" :custom-filter="filterGroups">
            <template v-slot:top>
              <v-toolbar class="elevation-0 rounded-lg">
                <v-toolbar-title class="text-subtitle-1 font-weight-bold">
                  {{ filteredGroups.length }} grupo(s)
                </v-toolbar-title>
                <v-btn-toggle v-model="statusFilter" mandatory dense color="primary" class="ml-4">
                  <v-btn small value="all" class="text-none">
                    Todos
                    <v-chip x-small class="ml-1" color="grey lighten-2">{{ groups.length }}</v-chip>
                  </v-btn>
                  <v-btn small value="pending" class="text-none">
                    Pendientes
                    <v-chip x-small class="ml-1" color="warning" text-color="white">{{ pendingGroupsCount }}</v-chip>
                  </v-btn>
                  <v-btn small value="processed" class="text-none">
                    Procesados
                    <v-chip x-small class="ml-1" color="success" text-color="white">{{ processedGroupsCount }}</v-chip>
                  </v-btn>
                </v-btn-toggle>
                <v-spacer></v-spacer>
                <v-col md="4">
                  <v-text-field label="Buscar grupo o usuario..." class="mt-0" v-model="search" outlined dense
                    hide-details clearable append-icon="mdi-magnify"></v-text-field>
                </v-col>
              </v-toolbar>
            </template>

            <template v-slot:[`item.date_out`]="{ item }">
              {{ formatDate(item.date_out) }}
            </template>

            <template v-slot:[`item.progress`]="{ item }">
              <v-chip small label :color="progressColor(item)" :text-color="progressTextColor(item)"
                class="font-weight-bold">
                {{ item.processed }} de {{ item.total_employees }}
              </v-chip>
            </template>

            <template v-slot:[`item.total_amount`]="{ item }">
              {{ currencyFormat(item.total_amount) }} {{ item.currency_code }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn small outlined color="primary" class="text-none" @click="openGroup(item)">
                <v-icon left small>mdi-arrow-right-circle</v-icon>
                {{ item.pending > 0 ? 'Procesar' : 'Ver detalle' }}
              </v-btn>
            </template>

            <template v-slot:no-data>
              <v-row justify="center" class="pt-10">
                <v-icon size="80px">mdi-account-cash-outline</v-icon>
              </v-row>
              <v-row justify="center" class="pb-6"> No hay grupos de liquidación </v-row>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  name: "BenefitInvoices",
  data() {
    return {
      loading: false,
      search: "",
      statusFilter: "pending",
      groups: [],
      lastFilters: {},
      headers: [
        { text: "Grupo", value: "benefit_group_id", align: "start" },
        { text: "Localidad", value: "location_name", align: "start" },
        { text: "Generado por", value: "user_fullname", align: "start" },
        { text: "Fecha salida", value: "date_out", align: "start" },
        { text: "Procesados", value: "progress", align: "center" },
        { text: "Total", value: "total_amount", align: "end" },
        { text: "Acción", value: "actions", align: "center", sortable: false },
      ],
    };
  },
  computed: {
    pendingGroupsCount() {
      return this.groups.filter((g) => parseInt(g.pending) > 0).length;
    },
    processedGroupsCount() {
      return this.groups.filter((g) => parseInt(g.pending) === 0).length;
    },
    filteredGroups() {
      if (this.statusFilter === "pending") {
        return this.groups.filter((g) => parseInt(g.pending) > 0);
      }
      if (this.statusFilter === "processed") {
        return this.groups.filter((g) => parseInt(g.pending) === 0);
      }
      return this.groups;
    },
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "-";
    },
    progressColor(item) {
      if (item.pending == 0) return "success";
      if (item.processed > 0) return "warning";
      return "grey lighten-2";
    },
    progressTextColor(item) {
      return item.processed > 0 || item.pending == 0 ? "white" : "grey darken-2";
    },
    filterGroups(value, search, item) {
      if (!search) return true;
      const term = search.toString().toLowerCase();
      return (
        String(item.benefit_group_id).includes(term) ||
        (item.user_fullname || "").toLowerCase().includes(term)
      );
    },
    changeBusiness(data) {
      this.getData(data);
    },
    async getData(data) {
      this.lastFilters = data;
      this.loading = true;
      try {
        const body = {
          business: data.business || null,
          location: data.location || 0,
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
        };
        const response = await this.api_Post("humanResource/benefit_groups_pending", body);
        const result = await response.json();
        this.groups = Array.isArray(result) ? result : [];
      } catch (error) {
        console.error(error);
        this.$toast.error("Error al cargar los grupos de liquidación");
      } finally {
        this.loading = false;
      }
    },
    openGroup(item) {
      this.$router.push({
        name: "BenefitGroupDetail",
        params: { benefit_group_id: item.benefit_group_id },
      });
    },
  },
};
</script>
